import React from "react";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import useGetActiveNoEmailAddress from "./hooks/useGetActiveNoEmailAddress";
import DownloadButton from "../../../../components/DownloadButton";
import { CSVLink } from "react-csv";
import { UsersIcon } from "@heroicons/react/24/solid";
import { useRecoilState, useRecoilValue } from "recoil";
import { mainSelectedTab } from "../../atoms";
import { useHistory } from "react-router-dom";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { employeeFromReports } from "../../Employees/Confie/atoms/atoms";
import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
import { EmployeeTabs } from "../../../EmployeeTab/EmployeeTab";
import { accountAtom } from "../../../Login/atoms/AccountAtom";

interface IActiveEmployeesNoEmailAddress {
  employeenumber: string;
  fullname: string;
  email: string;
  state: string;
  storeNumber: string;
  officeName: string;
  department: string;
  employeeTypeName: string;
  status: string;
  createdDate: string;
  hiredate: string;
  employmenttype: string;
  reportsToFullname: string;
}
interface useGetActiveNoEmailAddressProps {}
export const ActiveEmployeesNoEmailAddress: React.FC<
  useGetActiveNoEmailAddressProps
> = () => {
  const { data: employeesNoEmailAddress, isLoading: noEmailAddressLoading } =
    useGetActiveNoEmailAddress();
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const history = useHistory();
  const userPermissions = useRecoilValue(permissionsSelector);
  const [, setShowFromReports] = useRecoilState(employeeFromReports);
  const user = useRecoilValue(accountAtom);

  //Date Format
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [month, day, year].join("/");
  }

  const exportdata = employeesNoEmailAddress
    ?.filter((x) =>
      user.isFranchise && user.isNonFranchise
        ? x.employeeTypeName !== ""
        : user.isFranchise
        ? x.employeeTypeName?.toLowerCase() === "franchise"
        : x.employeeTypeName?.toLowerCase() !== "franchise"
    )
    .map((emp: IActiveEmployeesNoEmailAddress) => {
      return {
        "Full Name": emp.fullname,
        "Employee ID": '=""' + emp.employeenumber + '""',
        Email: emp.email,
        State: emp.state,
        "Local Office #": emp.storeNumber,
        "Office Name": emp.officeName,
        Department: emp.department,
        "Employee Type": emp.employeeTypeName,
        Status: emp.status,
        "Created Date": emp.createdDate ? formatDate(emp.createdDate) : "",
        "Hire Date": emp.hiredate ? formatDate(emp.hiredate) : "",
        "Employment Type": emp.employmenttype,
        "Reports To": emp.reportsToFullname,
      };
    });
  let dateTimeToday = new Date(new Date().toLocaleString()).toLocaleString();
  const csvReport = {
    filename: "ActiveEmployeesNoEmailAddress_" + dateTimeToday + ".csv",
    data: exportdata ? exportdata : [],
  };
  const employeeColumns = [
    {
      title: "Full Name",
      field: "fullname",
      render: (rowData) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => {
              const url = "/employeetab/employee";
              history.push({
                pathname: url,
                state: {
                  employeeNumber: rowData?.employeeid,
                  action: "NoEmailReports",
                },
              });
              window.location.reload();
              let userTabs = [
                {
                  to: "",
                },
              ];
              [...EmployeeTabs].forEach((tabs) => {
                let temp = [...userPermissions].filter(
                  (user) => user === tabs.permission
                );
                if (temp.length > 0)
                  userTabs.push({
                    to: tabs.to,
                  });
              });
              userTabs.shift();
              const index = userTabs.findIndex((c) => c.to === url);
              setSelectedIndex(index);
              setShowFromReports(true);
            }}
          >
            <span className="text-quinary  font-bold underline text-sm ">
              {rowData.fullname}
            </span>
          </div>
        );
      },
    },
    { title: "Employee ID", field: "employeenumber" },
    { title: "Email", field: "email" },
    { title: "State", field: "state" },
    { title: "Local Office #", field: "storeNumber" },
    {
      title: "Office Name",
      field: "officeName",
      render: (rowData) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => {
              const url = "/officesettings/officesetting";
              history.push({
                pathname: url,
                state: {
                  officeCode: rowData?.officecode,
                  action: "EmployeeNoEmailReports",
                },
              });
              window.location.reload();
              let userTabs = [
                {
                  to: "",
                },
              ];
              [...OfficeTabs].forEach((tabs) => {
                let temp = [...userPermissions].filter(
                  (user) => user === tabs.permission
                );
                if (temp.length > 0)
                  userTabs.push({
                    to: tabs.to,
                  });
              });
              userTabs.shift();
              const index = userTabs.findIndex((c) => c.to === url);
              setSelectedIndex(index);
            }}
          >
            <span className="text-quinary  font-bold underline text-sm ">
              {rowData.officeName}
            </span>
          </div>
        );
      },
    },
    { title: "Department", field: "department" },
    { title: "Employee Type", field: "employeeTypeName" },
    { title: "Status", field: "status" },
    {
      title: "Created Date",
      field: "createdDate",
      typeof: "date",
      dateSetting: { locale: "en-US", format: "MM/dd/yyyy" },
      render: (rowDetails) => {
        return (
          <div>
            <span className=" ">
              {rowDetails.createdDate ? formatDate(rowDetails.createdDate) : ""}
            </span>
          </div>
        );
      },
    },
    {
      title: "Hire Date",
      field: "hiredate",
      render: (rowDetails) => {
        return (
          <div>
            <span className=" ">
              {rowDetails.hiredate ? formatDate(rowDetails.hiredate) : ""}
            </span>
          </div>
        );
      },
    },
    { title: "Employment Type", field: "employmenttype" },
    { title: "Reports To", field: "reportsToFullname" },
  ];

  return (
    <div className="text-xs items-center">
      <div className="">
        <div className="mx-4 mt-4 overflow-x-auto">
          <div className="flex mb-2 gap-2 items-center">
            <div>
              <UsersIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
            </div>
            <div className="flex flex-col leading tight">
              <div className="text-gray-500 text-md font-medium">
                Report: Employees & Offices
              </div>
              <div className="flex items-center font-bold text-lg text-primary">
                Active Employees No Email Address
              </div>
            </div>
          </div>
          <div className="mt-2" />
          <div className="flex justify-between mb-2 mr-2">
            <div className="flex items-center gap-1">
              <span className="text-gray-500 text-sm">Total Records: </span>
              <span className="text-primary text-base font-semibold">
                {user.isFranchise && user.isNonFranchise
                  ? employeesNoEmailAddress?.length
                  : employeesNoEmailAddress?.filter(
                      (x) =>
                        x.employeenumber !== "" &&
                        (user.isFranchise
                          ? x.employeeTypeName?.toLowerCase() === "franchise"
                          : x.employeeTypeName?.toLowerCase() !== "franchise")
                    )?.length}
              </span>
            </div>
            <CSVLink {...csvReport}>
              <DownloadButton
                buttonValue="Download File"
                onClick={() => exportdata}
                className={undefined}
                disabled={undefined}
              />
            </CSVLink>
          </div>
        </div>
        <div className="box-shadow mx-4 mb-4 mt-2 overflow-x-auto grid grid-row">
          <MaterialTableTS
            data={
              user.isFranchise && user.isNonFranchise
                ? employeesNoEmailAddress
                : employeesNoEmailAddress?.filter(
                    (x) =>
                      x.employeenumber !== "" &&
                      (user.isFranchise
                        ? x.employeeTypeName?.toLowerCase() === "franchise"
                        : x.employeeTypeName?.toLowerCase() !== "franchise")
                  )
            }
            isLoading={noEmailAddressLoading}
            columns={employeeColumns}
            showTitle={false}
          />
        </div>
      </div>
    </div>
  );
};
